import { createContext, useContext, useState } from "react";
import { HomeContext } from "./ContextHome";
import { Outlet } from "react-router-dom";
import { apiSae } from "../services/api";

export const GradeContext = createContext({});

export const GradeProvider = () => {
  const [loading, setLoading] = useState(false);

  const { headerApi } = useContext(HomeContext);
  const [eventos, setEventos] = useState({ results: [] });
  const [modalAvisosEmegencia, setModalAvisosEmegencia] = useState(false);
  const [modalGraficoOpen, setModalGraficoOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [idDataPoco, setIdDataPoco] = useState(0);
  const [dataPoco, setDataPoco] = useState([]);
  const [modalEventosFalhas, setModalEventosFalhas] = useState(false);
  const [modalRelatorioGradeOn, setModalRelatorioGradeOn] = useState(false);
  const [dataGrade, setDataGrade] = useState([]);
  const [idDataGrade, setIdDataGrade] = useState(0);

  const listarEventos = async (id_estacao) => {
    try {
      const response = await apiSae.get(
        `alertas/Leitura/${id_estacao}`,
        headerApi
      );
      setEventos(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <GradeContext.Provider
      value={{
        headerApi,
        listarEventos,
        modalAvisosEmegencia,
        setModalAvisosEmegencia,
        eventos,
        modalGraficoOpen,
        setModalGraficoOpen,
        selectedDate,
        setSelectedDate,
        idDataPoco,
        setIdDataPoco,
        dataPoco,
        setDataPoco,
        modalEventosFalhas,
        setModalEventosFalhas,
        modalRelatorioGradeOn,
        setModalRelatorioGradeOn,
        dataGrade,
        setDataGrade,
        idDataGrade,
        setIdDataGrade,
        loading,
        setLoading,
      }}
    >
      <Outlet />
    </GradeContext.Provider>
  );
};
